module.exports = __webpack_public_path__ + "img/60_pourcent.608ab1a2.png";